module.exports = __webpack_public_path__ + "img/richard-pro.0bd2374a.jpg";